/**
 * MenuItemContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Screen from '@screen';
import styled from 'styled-components';

/**
 * Props for the menu item.
 */
interface Props {
  collapse: boolean;
  focused: boolean;
}

/**
 * Styled div for the menu item.
 */
const MenuItemContainer = styled.div<Props>`
  align-items: center;
  color: ${Colors['text']};
  cursor: ${({ collapse }) => (collapse ? 'default' : 'pointer')};
  display: flex;
  flex-direction: row;
  font-size: ${32 * Screen.widthRatio}px;
  height: ${32 * Screen.widthRatio}px;
  margin-bottom: ${38 * Screen.widthRatio}px;
  opacity: ${({ focused }) => (focused ? 1 : 0.5)};
  width: max-content;
`;

export default MenuItemContainer;
